export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 分类编号
                classificationNumber: '',
                classificatiocName: '',
                classificationPath: '',
                center: '',
            },
            // 所属中心
            center: [
                {
                    id: 1,
                    label: '郑州',
                    value: '郑州'
                }
            ],
            // 表格数据
            tableData: [
                {
                    id: 1,
                    classificationNumber: '水利工程',
                    classificatiocName: '水利工程',
                    classificationPath: '水利工程',
                    center: '20',
                },
                {
                    id: 2,
                    classificationNumber: '水利工程',
                    classificatiocName: '水利工程',
                    classificationPath: '水利工程',
                    center: '20',
                },
                {
                    id: 3,
                    classificationNumber: '水利工程',
                    classificatiocName: '水利工程',
                    classificationPath: '水利工程',
                    center: '20',
                },
                {
                    id: 4,
                    classificationNumber: '水利工程',
                    classificatiocName: '水利工程',
                    classificationPath: '水利工程',
                    center: '20',
                },
            ],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 新增课程分类对话框
            addClassificationDialog: false,
            // 新增课程分类的表单数据
            addform: {
                // 分类编号
                classificationNumber: '',
                classificatiocName: '',
                classificationPath: '',
                displayPosition: '',
            },
            // 修改课程分类对话框
            editClassificationDialog: false,
            // 修改课程分类的表单数据
            editform: {
                // 分类编号
                classificationNumber: '',
                classificatiocName: '',
                classificationPath: '',
                displayPosition: '',
            },
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {

        // 搜索
        search() {
            console.log(this.form);
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 新增子级课程分类，子级需要有选择记录
        addNewChild() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            this.addClassificationDialog = true;
        },

        // 新增同级课程分类
        addNewClass() {
            this.selectionIds = [];
            this.addClassificationDialog = true;
        },

        // 确定新增课程分类
        addClassification() {
            // 发送请求添加
            this.$message.success('添加成功！');
            this.addClassificationDialog = false;
        },

        // 点击修改按钮
        edit() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            this.editClassificationDialog = true;

            // 发送请求获取数据
            this.editform = {
                id: 1,
                classificationNumber: '水利工程',
                classificatiocName: '水利工程',
                classificationPath: '水利工程',
                displayPosition: 20,
            };
        },

        // 确定修改课程分类
        editClassification() {
            // 发送请求修改
            this.$message.success('修改成功！');
            this.editClassificationDialog = false;
        },

        // 删除分类
        deleteClassification() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
            // 发送请求删除
            this.$message.success('删除成功！');
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },

    }
}